import { Box } from "@mui/material";
import { gray } from "configs/colors";

const Divider: React.FC = () => {
  return <Box width="100%" borderBottom={`1px solid ${gray[200]}`} />;
};

export default Divider;
